module.exports = __webpack_public_path__ + "img/content.a24fdeb9.jpg";